import axios, { AxiosRequestConfig } from 'axios';
import { useAuthStore } from '@/store/auth/auth.store';
import { ApiResponse } from '../interfaces/erp/global/response-axios.interface';
import { toApiError } from '../utils/general/axios.utils';
import { toast } from 'react-toastify';
export type ErpApiParams = {
  isStorageApi?: boolean;
  isCedulaRucApi?: boolean;
  customTimeOut?: number;
};

//const customTimeOut = 600000; // 10 min
//const customTimeOut = 120000 // 2 min

export const erpApi = ({ customTimeOut = 600000 }: ErpApiParams = {}) => {

  const sendRequest = async <T>(
    method: string,
    url: string,
    auth: boolean,
    typeJson: boolean = true,
    data = null
  ): Promise<ApiResponse<T>> => {
    const storedToken = useAuthStore.getState().token;
    // logout esta deshabilitado: las llamadas a logout().then() en los
    // handlers de error 401 estan comentadas (lineas ~66 y ~94). Cuando
    // se reactiven, restaurar:
    const logout = useAuthStore.getState().logOutWithoutToken;

    // calc url
    const urlApi = url;

    const config: AxiosRequestConfig = {
      method: method,
      url: urlApi,
      data: data,
      responseType: typeJson ? 'json' : 'blob',
      timeout: customTimeOut, // 2 minutos
    };

    if (auth) {
      config.headers = {
        Authorization: 'Token ' + storedToken,
      };
    }


    let dataResp;
    try {
      dataResp = (await axios<ApiResponse<T>>(config)).data;
      return dataResp;
    } catch (error) {

      const errorApi = toApiError(error)

      const requestUrl: string = (error as any)?.config?.url || '';
      const esEndpointMicroservicio =
        requestUrl.includes('/api/v1/gestion-tickets/') ||
        requestUrl.includes('/api/v1/campanas/') ||
        requestUrl.includes('/api/campanias/') ||
        requestUrl.includes('/api/v1/noc/') ||
        requestUrl.includes('/api/v1/orden-servicio/') ||
        requestUrl.includes('/api/v1/proveedores/');
        requestUrl.includes('/api/v1/reports/');

      if (errorApi.type == 'backend-error' && !esEndpointMicroservicio) {
        toast.error(errorApi.message)
      }

      if (errorApi.status == 401) {
        if (!esEndpointMicroservicio) {
          toast.error(errorApi.message)
          logout().then(() => {
            window.location.reload();
          });
        }
      }

      throw error;

      /* if (isAxiosError(error)) {

        switch (error.code) {
          case 'ECONNABORTED':
            setAlert(
              true,
              'El servidor no responde. Inténtelo de nuevo más tarde. [ECONNABORTED]',
              AlertSeverityEnum.error
            );
            throw error;
          case 'ERR_NETWORK':
            
            throw error;
        }

        switch (error.response?.status) {
          case 502:
            setAlert(true, 'Error de conexión: [502]', AlertSeverityEnum.error);
            throw error;
          case 401:
            setAlert(true, 'Sesión expirada: [401]', AlertSeverityEnum.error);
            logout().then(() => {
              window.location.reload();
            });
            throw error;
          case 403:
            setAlert(true, 'Acceso denegado. No cumples con los permisos necesarios: [403]', AlertSeverityEnum.error);
            throw error;
        }

        throw error;
      }

      throw error; */
    }
  };

  const get = async function <T>(
    url: string,
    auth: boolean,
    typeJson: boolean = true
  ): Promise<ApiResponse<T>> {
    return sendRequest<T>('GET', url, auth, typeJson);
  };

  const post = async function <T>(
    url: string,
    data: any,
    auth: boolean,
    typeJson: boolean = true
  ): Promise<ApiResponse<T>> {
    return sendRequest<T>('POST', url, auth, typeJson, data);
  };

  const put = async function <T>(
    url: string,
    data: any,
    auth: boolean,
    typeJson: boolean = true
  ): Promise<ApiResponse<T>> {
    return sendRequest<T>('PUT', url, auth, typeJson, data);
  };

  const patch = async function <T>(
    url: string,
    data: any,
    auth: boolean,
    typeJson: boolean = true
  ): Promise<ApiResponse<T>> {
    return sendRequest<T>('PATCH', url, auth, typeJson, data);
  };

  const remove = async function <T>(
    url: string,
    auth: boolean,
    typeJson: boolean = true
  ): Promise<ApiResponse<T>> {
    return sendRequest<T>('DELETE', url, auth, typeJson);
  };

  return {
    get,
    post,
    put,
    patch,
    remove,
  };
};
